import { Link } from "react-router-dom";

// ROAM wordmark — Archivo Expanded Bold, tracked wide, the letter A always in larch gold.
export const Wordmark = ({
  className = "",
  color = "#24382E",
  goldColor = "#C89A4E",
  showSub = false,
  subColor,
  size = "text-2xl",
  asLink = true,
  testId = "wordmark",
}) => {
  const content = (
    <span className="inline-flex flex-col leading-none">
      <span
        className={`font-expanded font-extrabold ${size}`}
        style={{ color, letterSpacing: "0.18em" }}
      >
        RO<span style={{ color: goldColor }}>A</span>M
      </span>
      {showSub && (
        <span
          className="label-caps mt-1"
          style={{
            color: subColor || color,
            fontSize: "9px",
            letterSpacing: "0.34em",
            opacity: 0.7,
          }}
        >
          Living · Alberta
        </span>
      )}
    </span>
  );

  if (!asLink) return <span className={className} data-testid={testId}>{content}</span>;

  return (
    <Link
      to="/"
      className={`inline-block ${className}`}
      data-testid={testId}
      aria-label="ROAM Living — home"
    >
      {content}
    </Link>
  );
};

export default Wordmark;
